import {getTextByValue} from "../../Utilities/Types/listUtilities";
import {
    COMPLETE_READING_MEDIUMS_LIST,
    GRADE_LEVEL_LIST,
    LANGUAGE_LIST,
    STUDENT_APPROVAL_STATUS_LIST, STUDENT_ELIGIBILITY_LIST
} from "./studentConstants";

export const getGradeLevelTextByValue = (value: string | number) => getTextByValue(GRADE_LEVEL_LIST, value);
export const getLanguageTextByValue = (value: string | number) => getTextByValue(LANGUAGE_LIST, value);
export const getCompleteReadingMediumsTextByValue = (value: string | number) => getTextByValue(COMPLETE_READING_MEDIUMS_LIST, value);
export const getStudentApprovalStatusTextByValue = (value: string | number) => getTextByValue(STUDENT_APPROVAL_STATUS_LIST, value);
export const getEligibilityTextByValue = (value: string | number) => getTextByValue(STUDENT_ELIGIBILITY_LIST, value);
